import { Link } from "react-router-dom";
import type { LegalBlock, LegalListItem, LegalTextPart } from "../content/legalDocument";
import { linkAccent } from "../lib/ui";

function renderPart(part: LegalTextPart, key: number) {
  if (typeof part === "string") {
    return <span key={key}>{part}</span>;
  }
  if ("bold" in part) {
    return <strong key={key}>{part.bold}</strong>;
  }
  if (part.external || part.href.startsWith("http")) {
    return (
      <a key={key} href={part.href} target="_blank" rel="noreferrer" className={linkAccent}>
        {part.link}
      </a>
    );
  }
  return (
    <Link key={key} to={part.href} className={linkAccent}>
      {part.link}
    </Link>
  );
}

function renderParts(parts: LegalTextPart[]) {
  return parts.map((part, index) => renderPart(part, index));
}

function LegalList({ items, className }: { items: LegalListItem[]; className?: string }) {
  return (
    <ul className={className ?? "mt-3 list-disc space-y-2 pl-5 text-sm text-muted-foreground leading-relaxed"}>
      {items.map((entry) => (
        <li key={entry.parts.map((part) => (typeof part === "string" ? part : JSON.stringify(part))).join("")}>
          <span>{renderParts(entry.parts)}</span>
          {entry.children && entry.children.length > 0 ? (
            <LegalList items={entry.children} className="mt-2 list-disc space-y-2 pl-5" />
          ) : null}
        </li>
      ))}
    </ul>
  );
}

function LegalBlockView({ block }: { block: LegalBlock }) {
  if (block.type === "p") {
    return <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{renderParts(block.parts)}</p>;
  }
  return <LegalList items={block.items} />;
}

export default function LegalDocumentContent({ blocks }: { blocks: LegalBlock[] }) {
  return (
    <>
      {blocks.map((block, index) => (
        <LegalBlockView key={index} block={block} />
      ))}
    </>
  );
}
